import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { environment } from "../../../environments/environment";
import { CmsService } from 'src/app/Services/cms.service';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  standalone: false
})
export class PageNotFoundComponent implements OnInit{
  language: string = '';
  defaultLanguage: string = environment.defaultLanguage;

  page404_content: string = 'linhas-404';
  page404Info: any = {};

  constructor(
    private cmsService: CmsService,
    private router: Router,
    private translate: TranslateService,
    private title: Title
  ) {
    let lang = localStorage.getItem('language') ?? this.defaultLanguage;
    this.language = lang.split('-')[0];

    this.title.setTitle('Linhas | Transportes do Douro, Tâmega e Sousa');
  }

  ngOnInit(){
    this.getContent();
  }

  getContent(){
    this.cmsService.getContentList(this.page404_content, this.language).subscribe(
      {
        next: data => {
          this.page404Info = data['body']['data'];

        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    );
  }
}
